import {
  Box,
  Grid,
  Typography,
  Button,
  ThemeProvider,
  Toolbar,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'react-lottie';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  createReservation,
  createReservationNoPayment,
  createWaitlistOffline,
  getRestaurantDetails,
} from '../../api';
import Loader from '../../Main/Components/Common/Loader';
import logo from '../../Assets/logo/logo.svg';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet-async';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Modal from '@mui/material/Modal';
import { PiClockUserThin } from 'react-icons/pi';
import { Theme, ThemeForno, ThemeTerrace, ThemePrive } from '../../Themes';
import coinAnime from '../../Assets/anime/coin.json';
import {
  isForno_Color,
  isReisty_Color,
  isTerrace_Color,
  isPrive_Color,
  isMaisonPrive,
  houseRulesContentSx,
  isNok_Color,
} from './WidgetConfig';
import { generateUniqueCode } from './InformationWidget';
import WidgetHeader from './Components/widget-header';
import HeaderSection from './Components/HeaderSection';
import GuestDetailsPanel from './Components/GuestDetailsPanel';
import ReservationConfirmPanel from './Components/ReservationConfirmPanel';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: 400, md: 400, sm: 350, xs: 350 },
  bgcolor: 'background.paper',

  boxShadow: 24,
  p: 4,
  boxSizing: 'border-box',
  borderRadius: '10px',
  maxHeight: '70vh',
  overflowY: 'scroll',
};

const InformationWidgetUser = ({}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [Dietary, setDietary] = useState('');
  const [birthMonth, setBirthMonth] = useState('');
  const [birthDay, setBirthDay] = useState('');
  const [title, setTitle] = useState('');
  const [occasion, setOccasion] = useState('');
  const [specialRequest, setSpecialRequest] = useState('');
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const [loading, setLoading] = useState(false);
  const [otherOccasions, setOtherOccasions] = useState('');
  const [guestDetails, setGuestDetails] = useState(null);
  const [openWaitlist, setOpenWaitlist] = useState(false);
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const nameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const emailError = '';
  const mobileError = '';
  const [activeStep, setActiveStep] = useState(1);
  const [canAccept, setCanAccept] = useState(false);
  const contentRef = useRef(null);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: coinAnime,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    if (occasion !== '') {
      setOtherOccasions('');
    }
  }, [occasion]);

  useEffect(() => {
    if (otherOccasions !== '') {
      setOccasion('');
    }
  }, [otherOccasions]);

  const [restaurant, setRestaurant] = useState(null);
  const {
    restaurantName,
    guest,
    time,
    date,
    deposit,
    floor,
    waitlist,
    pointValue,
    point_id,
    charges,
  } = queryParams;
  const user = useSelector((state) => state.user.user);

  const handleAlert = (variant, message) => {
    enqueueSnackbar(message, { variant });
  };

  useEffect(() => {
    setFirstName(user?.first_name);
    setLastName(user?.last_name);
    setEmail(user?.email);
    setPhoneNumber(user?.phone_number);
  }, [user]);

  const [dobError, setDobError] = useState(false);

  const handleCreateReservation = async () => {
    setIsLoading(true);
    if (IS_NEST && (!month || !day)) {
      setDobError(true);
      setIsLoading(false); // <— STOP LOADING
      return; // <— STOP FUNCTION
    }

    const ref = generateUniqueCode();
    const NewsAndUpdates = true;
    const EmailsAndOffers = true;
    const useWithWalletBalance = true;
    const newDeposit = deposit;
    await createReservation(
      restaurant?.RestaurantId,
      floor,
      email,
      point_id || null,
      date,
      time,
      parseFloat(guest),
      phoneNumber,
      newDeposit,
      ref,
      guestDetails,
      occasion || otherOccasions,
      Dietary?.join(', '),
      specialRequest,
      EmailsAndOffers,
      NewsAndUpdates,
      useWithWalletBalance,
      rulesChecked,
      month,
      day,
    )
      .then((res) => {
        if (res?.data?.status) {
          window.location.href = res?.data?.result?.authorization_url;
        } else {
          handleAlert('error', `${res?.data?.error_message}`);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err)
        setIsLoading(false);
        handleAlert('error', `${err?.message}`);
      });
  };
  const handleWaitlistReservation = async () => {
    setIsLoading(true);
    await createWaitlistOffline(
      restaurant?.RestaurantId,
      floor,
      point_id || null,
      date,
      time,
      firstName,
      lastName,
      phoneNumber,
      email,
      parseFloat(guest),
      occasion || otherOccasions,
      Dietary?.join(', '),
      specialRequest,
      null,
      true,
    )
      .then((res) => {
        if (res?.data?.status) {
          setOpenWaitlist(true);
        } else {
          handleAlert('error', `${res?.data?.error_message}`);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        handleAlert('error', `${err?.message}`);
      });
  };
  const handleCreateReservation2 = async () => {
    setIsLoading(true);

    const NewsAndUpdates = true;
    const EmailsAndOffers = true;
    const useWithWalletBalance = true;
    if (IS_NEST && (!month || !day)) {
      setDobError(true);
      setIsLoading(false); // <— STOP LOADING
      return; // <— STOP FUNCTION
    }
    await createReservationNoPayment(
      restaurant?.RestaurantId,
      floor,
      null,
      date,
      time,
      guest,
      phoneNumber,
      deposit,
      null,
      guestDetails,
      occasion || otherOccasions,
      Dietary?.join(', '),
      specialRequest,
      EmailsAndOffers,
      NewsAndUpdates,
      useWithWalletBalance,
      true,
      month,
      day,
    )
      .then((res) => {
        if (res?.data?.status) {
          navigate(`/reservation/booked/${res?.data?.result[0]?.BookingId}`);
        } else {
          handleAlert('error', `${res?.data?.error_message}`);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err)
        setIsLoading(false);
        handleAlert('error', `${err?.message}`);
      });
  };

  const handleGetRestaurantDetails = async () => {
    setLoading(true);
    await getRestaurantDetails(restaurantName)
      .then((res) => {
        setLoading(false);
        // console.log(res);
        if (res?.data?.status) {
          setRestaurant(res?.data?.result[0]);
        }
      })
      .catch((err) => {
        setLoading(false);
        // console.log(err);
      });
  };

  useEffect(() => {
    handleGetRestaurantDetails();
  }, []);

  const [rulesChecked, setRulesChecked] = useState(false);

  const [currentTheme, setCurrentTheme] = useState(Theme);
  const [currentColor, setCurrentColor] = useState(isReisty_Color);

  // =======Restaurant config========

  const IS_TERRACE = restaurantName === 'the-terrace-lagos';
  const IS_FORNO = restaurantName === 'forno-lagos';
  const IS_NEST = restaurantName === 'nest-lagos';
  const IS_PRIVE = isMaisonPrive(restaurantName);
  const IS_NOK = restaurantName === 'nok-by-alara';

  useEffect(() => {
    if (IS_TERRACE) {
      setCurrentColor(isTerrace_Color);
      setCurrentTheme(ThemeTerrace);
    } else if (IS_FORNO) {
      setCurrentColor(isForno_Color);
      setCurrentTheme(ThemeForno);
    } else if (IS_PRIVE) {
      setCurrentColor(isPrive_Color);
      setCurrentTheme(ThemePrive);
    } else if (IS_NOK) {
      setCurrentColor(isNok_Color);
      setCurrentTheme(ThemeNok);
    } else {
      setCurrentColor(isReisty_Color);
      setCurrentTheme(Theme);
    }
  }, [restaurantName]);

  const IS_SHIRO = restaurantName === 'shiro';
  const IS_HARDROCK = restaurantName === 'hard-rock-cafe';

  const deposit_charge = parseFloat(charges) || 0;
  const selectedFloorPlanName = restaurant?.FloorPlans?.find(
    (plan) => String(plan?.Id) === String(floor),
  )?.Name;
  const hasHouseRules =
    restaurant?.Experience?.HouseRules &&
    restaurant?.Experience?.HouseRules !== '<p>﻿</p>';
  const validateGuestDetailsForm = () => {
    const newName = firstName.trim();
    const newLname = lastName.trim();
    const newEmail = email.trim();

    if (!newName) {
      nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      nameRef.current?.focus();
      return false;
    }

    if (!newLname) {
      lastNameRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      lastNameRef.current?.focus();
      return false;
    }

    if (!phoneNumber || mobileError) {
      phoneRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      phoneRef.current?.focus();
      return false;
    }

    if (!newEmail || emailError) {
      emailRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      emailRef.current?.focus();
      return false;
    }

    return true;
  };

  const isReviewDisabled =
    !firstName || !lastName || !email || !!emailError || !!mobileError;
  const isConfirmDisabled =
    isReviewDisabled || (hasHouseRules && !rulesChecked);
  const confirmLabel =
    waitlist === 'true'
      ? 'Join the waitlist'
      : Number(deposit) > 0
        ? 'Make Payment Online'
        : 'Complete Reservation';

  const handleGoToReview = () => {
    if (!validateGuestDetailsForm()) return;
    setActiveStep(2);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleConfirm = () => {
    if (!validateGuestDetailsForm()) {
      setActiveStep(1);
      return;
    }
    if (waitlist === 'true') {
      handleWaitlistReservation();
    } else if (Number(deposit) > 0) {
      handleCreateReservation();
    } else {
      handleCreateReservation2();
    }
  };

  const handleScroll = () => {
    const el = contentRef.current;

    if (!el) return;

    const isAtBottom =
      Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight - 4;

    if (isAtBottom) {
      setCanAccept(true);
    }
  };

  useEffect(() => {
    if (!open) {
      setCanAccept(false);
      return;
    }

    setCanAccept(false);

    const frame = window.requestAnimationFrame(() => {
      const el = contentRef.current;

      if (el && el.scrollHeight <= el.clientHeight + 4) {
        setCanAccept(true);
      }
    });

    return () => window.cancelAnimationFrame(frame);
  }, [open]);

  const handleFormSubmit = (guests) => {
    setGuestDetails(guests);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <ThemeProvider theme={currentTheme}>
        {isLoading && <Loader />}
        <WidgetHeader
          activeStep={activeStep}
          backHref={
            activeStep === 1 ? `/${restaurantName}/reservation` : undefined
          }
          onBack={activeStep === 2 ? () => setActiveStep(1) : undefined}
          showClose
          onClose={() => navigate(`/${restaurantName}/reservation`)}
        />
        {isSuccessful ? (
          <>
            <Box
              sx={{
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mt: 4,
                bgcolor: currentColor.mainbg,
              }}
            >
              <Lottie options={defaultOptions} width={400} height={200} />
              <Typography sx={{ fontSize: '18px', fontWeight: 700 }}>
                Reservation Modified
              </Typography>
              <Typography>
                Please check your inbox for a confirmation email.
              </Typography>
            </Box>
          </>
        ) : activeStep === 1 ? (
          <Box
            sx={{
              bgcolor: currentColor.mainbg,
              minHeight: '100vh',
              pb: 4,
            }}
          >
            {/* <Box
              align="center"
              sx={{ pt: 4, pb: 1.5, bgcolor: currentColor.mainbg }}
            >
              <img src={logo} width={90} />
              <Typography sx={{ mt: 2, fontWeight: 700, fontSize: '16px' }}>
                Complete Reservation
              </Typography>
            </Box> */}
            <Box
              sx={{
                margin: '0 auto',
                width: {
                  xl: '80%',
                  lg: '80%',
                  md: '90%',
                  sm: '100%',
                  xs: '100%',
                },
                bgcolor: currentColor.mainbg,
                minHeight: '100vh',
                pb: 4,
                overflow: 'visible',
              }}
            >
              <Toolbar />
              <Box
                sx={{
                  maxWidth: 1100,
                  mx: 'auto',
                  px: { xs: 2, sm: 3 },
                  py: { xs: 3, md: 4 },
                  overflow: 'visible',
                }}
              >
                <Grid
                  container
                  spacing={{ xs: 3, md: 4 }}
                  alignItems="flex-start"
                  sx={{ overflow: 'visible' }}
                >
                  <Grid
                    item
                    xs={12}
                    md={5}
                    sx={{
                      position: { xs: 'static', md: 'sticky' },
                      top: { md: 56 },
                      alignSelf: 'flex-start',
                      height: 'fit-content',
                      zIndex: 2,
                    }}
                  >
                    <HeaderSection restaurant={restaurant} />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <GuestDetailsPanel
                      firstName={firstName}
                      setFirstName={setFirstName}
                      lastName={lastName}
                      setLastName={setLastName}
                      email={email}
                      handleEmailChange={(e) => setEmail(e.target.value)}
                      emailError={emailError}
                      phoneNumber={phoneNumber}
                      handleMobileChange={(value) => setPhoneNumber(value)}
                      mobileError={mobileError}
                      nameRef={nameRef}
                      lastNameRef={lastNameRef}
                      emailRef={emailRef}
                      phoneRef={phoneRef}
                      guest={guest}
                      handleFormSubmit={handleFormSubmit}
                      occasion={occasion}
                      setOccasion={setOccasion}
                      otherOccasions={otherOccasions}
                      setOtherOccasions={setOtherOccasions}
                      month={month}
                      setMonth={setMonth}
                      day={day}
                      setDay={setDay}
                      dobError={dobError}
                      IS_NEST={IS_NEST}
                      setDietary={setDietary}
                      specialRequest={specialRequest}
                      setSpecialRequest={setSpecialRequest}
                      currentColor={currentColor}
                      submitLabel="Review Reservation >"
                      onSubmit={handleGoToReview}
                      isSubmitDisabled={isReviewDisabled}
                      guestTitle={title}
                      setGuestTitle={setTitle}
                      birthDay={birthDay}
                      setBirthDay={setBirthDay}
                      setBirthMonth={setBirthMonth}
                      birthMonth={birthMonth}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              bgcolor: currentColor.mainbg,
              minHeight: '100vh',
              pb: 4,
            }}
          >
            <Box align="center" sx={{ pt: 4, pb: 1.5 }}>
              <img src={logo} width={90} />
              <Typography sx={{ mt: 2, fontWeight: 700, fontSize: '16px' }}>
                Complete Reservation
              </Typography>
            </Box>

            <Box
              sx={{
                maxWidth: 1100,
                mx: 'auto',
                px: { xs: 2, sm: 3 },
                mt: 2,
              }}
            >
              <ReservationConfirmPanel
                floor={floor}
                restaurant={restaurant}
                restaurantName={restaurantName}
                date={date}
                time={time}
                guest={guest}
                guestDetails={guestDetails}
                floorPlanName={selectedFloorPlanName}
                Dietary={Dietary}
                specialRequest={specialRequest}
                occasion={occasion}
                otherOccasions={otherOccasions}
                deposit={deposit}
                deposit_charge={deposit_charge}
                waitlist={waitlist}
                currentColor={currentColor}
                IS_SHIRO={IS_SHIRO}
                IS_HARDROCK={IS_HARDROCK}
                loading={loading}
                rulesChecked={rulesChecked}
                handleOpen={handleOpen}
                pointValue={pointValue}
                point_id={point_id}
                lottieOptions={defaultOptions}
                onEditDetails={() => {
                  setActiveStep(1);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                onConfirm={handleConfirm}
                isConfirmDisabled={isConfirmDisabled}
                confirmLabel={confirmLabel}
                confirmLoading={isLoading}
              />
            </Box>
          </Box>
        )}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              ...style,
              height: '80vh',
              display: 'flex',
              flexDirection: 'column',
              p: 0,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                p: 3,
                borderBottom: '1px solid',
                borderColor: 'divider',
                flexShrink: 0,
                bgcolor: 'background.paper',
              }}
            >
              <Typography
                sx={{
                  fontSize: '20px',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
              >
                House Rules
              </Typography>
            </Box>

            <Box
              ref={contentRef}
              onScroll={handleScroll}
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                px: 3,
                py: 2,
                bgcolor: 'background.paper',
                ...houseRulesContentSx,
              }}
            >
              <ReactQuill
                value={restaurant?.Experience?.HouseRules}
                readOnly
                theme={null}
                modules={{ toolbar: false }}
                style={{
                  fontFamily: 'lato',
                  padding: '0%',
                }}
                className="ql-editor"
              />
            </Box>

            <Box
              sx={{
                p: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
                flexShrink: 0,
                bgcolor: 'background.paper',
              }}
            >
              <Button
                fullWidth
                disabled={!canAccept}
                sx={{
                  height: '45px',
                  borderRadius: '14px',
                }}
                variant="contained"
                onClick={() => {
                  setRulesChecked(true);
                  handleClose();
                }}
              >
                {canAccept ? 'Accept' : 'Scroll to the bottom to continue'}
              </Button>
              <Button
                fullWidth
                sx={{
                  height: '45px',
                  borderRadius: '14px',
                  mt: 2,
                }}
                variant="outlined"
                onClick={() => {
                  handleClose();
                }}
              >
                Reject
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={openWaitlist}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box sx={{ mt: 2 }} align="center">
              <PiClockUserThin
                style={{ fontSize: '60px', color: '#FFA500 ' }}
              />
              <h3
                style={{
                  fontFamily: 'optima',
                  textAlign: 'center',
                  fontSize: '30px',
                }}
              >
                You’re Now on the Waitlist
              </h3>
              <Typography sx={{ mt: -3 }}>
                We’re preparing to accommodate you. Please wait for further
                updates.
              </Typography>
            </Box>

            <Box align="center" sx={{ mt: 5 }}>
              <Button
                variant="contained"
                sx={{ width: '230px', height: '45px', borderRadius: '8px' }}
                onClick={(e) => {
                  navigate(`/${restaurantName}/reservation`);
                }}
              >
                Thank You
              </Button>
            </Box>
          </Box>
        </Modal>
      </ThemeProvider>
    </>
  );
};

export default InformationWidgetUser;
